export enum IceHockeyMissedPenaltyAttribute {
  PenaltySaved = 812,
  EvenStrength = 813,
  PowerPlay = 814,
  Shorthanded = 815,
}
